import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { DeungiListRequestDto } from "../dto/DeungiList.dto";

export const useCorpDeungiList = async (params?: DeungiListRequestDto) => {
    const queryString = new URLSearchParams(params as any).toString();
    const response = await axiosInstance.get(`${axiosPath.corpDeungiList}?${queryString}`);
    return response;
};
